/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Audits_TaglineInputs */



/**
* | output |
* | --- |
* | "TMSA, OVMSA, MTMSA, STS assessments and navigation and office audits." |
*
* @param {Service_Audits_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_audits_tagline = /** @type {((inputs?: Service_Audits_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Audits_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("TMSA、OVMSA、MTMSA、STS 评估以及航行和办公室审核。")
	return /** @type {LocalizedString} */ ("TMSA, OVMSA, MTMSA, STS assessments and navigation and office audits.")
});